import { gql } from '@apollo/client';

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      access_token
      expires_in
      refresh_token
    }
  }
`;
